export default __webpack_public_path__ + "static/media/pic4.d956663e.jpg";